import React , {Component, Fragment} from 'react'
import { Row, DatePicker, Form , Col, Input, Button, Select, Table, InputNumber, Modal , message, Descriptions } from 'antd'
import FormItem from 'antd/lib/form/FormItem'
import moment from 'moment'
import axios from 'axios'
import { connect } from 'react-redux'
import {calculate_commission} from './utils'
import Payslip from '../../Payslip'


const {confirm} = Modal

const allowanceTypes = ["Travel" , "Food", "Other"]
const deductionTypes = ["Fine", "Late" , "No Pay" , "Other"]

const {Option} = Select


class Payroll extends Component{

    state = {
        from_date : moment().add("M",-1),
        to_date : moment(),
        emp_nic : "98686555V",
        emp_name: "Harry Potter",
        basic_salary:0,
        sales_bins: [],
        collection_bins:[],
        cash_sales_bins:[],
        show_cash_sales_bins:false,
        show_sales_bins:false,
        show_collection_bins : false,
        cash_sale_commission : 0,
        installment_sale_commission:0,
        collection_commission : 0,
        allowances : [],
        deductions : []

    }

    componentDidMount () {
        console.log(this.props.match.params.id)
        this.fetchPayrolldata(this.props.match.params.id)
    }

   
    fetchPayrolldata = (emp_id,successCallback=()=>{},errorCallback=()=>{}) => {
        axios.post(`${this.props.entity.server}/hr/employee/${emp_id}/totalsales`,
            {
                from: this.state.from_date.format("YYYY-MM-DD")+"T00:00:00" , 
                to: this.state.to_date.format("YYYY-MM-DD")+"T23:59:50"
            }
            )
        .then(
            response => {
                console.log(response.data)
                this.setState({
                    ...response.data,
                    from_date: moment(response.data.from_date),
                    to_date : moment(response.data.to_date)
                  
                }
                ,
                successCallback
                )
            }
        )
        .catch(
            error => {
                console.error(error)
                errorCallback()
            }
        )
    }

    onDateChange = (dateType , date) => {
        console.log(dateType,date)
        if(date){
            switch(dateType){
                case "from_date":{
                    this.setState(
                        {from_date:date} , () => {
                            console.log(this.state)
                            this.fetchPayrolldata(this.props.match.params.id)
                        }       
                    )
                    break;
                }
                case "to_date":{
                    this.setState(
                        {to_date:date} , () => {
                            console.log(this.state)
                            this.fetchPayrolldata(this.props.match.params.id)
                        }       
                    )
                    break;
                }
                default :{
                    message.error("default")
                }
            }
        
        }

    }

    onNumberChange = (valueType ,value) => {
            
            this.setState({[valueType]:value} , ()=> console.log(this.state))

        }
    
    
    formatTableData = () => {
        return [
            {
                key : 1 ,
                paymentType : "Basic Salary",
                amount : this.state.basic_salary

            },
            {
                key : 2 ,
                paymentType : "Cash Sales Commission",
                amount : this.state.cash_sale_commission

            },
            {
                key : 3 ,
                paymentType : "Installment Sales Commission",
                amount : this.state.installment_sale_commission

            },
            {
                key : 4 ,
                paymentType : "Collection Commision",
                amount : this.state.collection_commission

            },
            ...this.state.allowances,
            ...this.state.deductions.map(deduction=>({...deduction, amount: -1 * deduction.amount}))
        ]
    }


    bin_columns = [
        {
            key : 1,
            dataIndex : "incentive",
            title : "Incentive"
        }
        ,
        {
            key : 2,
            dataIndex : "lower",
            title : "Lower"
        }
        ,
        {
            key : 3,
            dataIndex : "upper",
            title : "Upper"
        }
    ]


 


    columns = [
        {
            key : 1,
            dataIndex : "paymentType",
            title: "Payment Type"
        }
        ,
        {
            key : 2,
            dataIndex : "amount",
            title: "Amount"
        }
    ]


    handleCommisionPlanOk = (type) => {
    
    switch(type){
        case "cash_sales":{
            this.setState({show_cash_sales_bins:false})
            const commision = calculate_commission(this.state.cash_sales_bins , this.state.total_cash_sale)
            this.setState(
                {
                    cash_sale_commission : commision
                }
            )
            break;
        }
        case "installment_sales":{
            this.setState({show_sales_bins:false})
            const commision = calculate_commission(this.state.sales_bins , this.state.total_installment_sale)
            this.setState(
                {
                    installment_sale_commission : commision
                }
            )
            break;
        }
        case "collection" : {
            this.setState({show_collection_bins:false})
            const commision = calculate_commission(this.state.collection_bins , this.state.total_collection)
            this.setState(
                {
                    collection_commission : commision
                }
            )
            break;
        }
        default:{
            console.error("handle commision default case!")
        }

    }
       
    }

    onAddRuleButtonClicked = (e) => {

        var isError = false

        if(this.state.bin_lower > this.state.bin_upper){
            isError = true;
            message.error("Lower should be lower than Upper!")
        }


        if(!isError){
        switch(e.target.name){
            case "cash_sales" :{
                const cash_sales_bins = this.state.cash_sales_bins
                cash_sales_bins.push({
                    key:this.state.bin_lower,
                    "incentive":this.state.bin_incentive,
                    "lower":this.state.bin_lower,
                    "upper" : this.state.bin_upper
                })
                this.setState(
                    {
                        cash_sales_bins:cash_sales_bins,
                        bin_per:0,
                        bin_lower :0,
                        bin_upper:0            
                    }
                )
                break;
            }
            case "installment_sales" :{
                const sales_bins = this.state.sales_bins
                sales_bins.push({
                    key:this.state.bin_lower,
                    "incentive":this.state.bin_incentive,
                    "lower":this.state.bin_lower,
                    "upper" : this.state.bin_upper
                })
                this.setState(
                    {
                        sales_bins:sales_bins,
                        bin_per:0,
                        bin_lower :0,
                        bin_upper:0            
                    }
                )
                break;
            }
            case "collection" :{
                const collection_bins = this.state.collection_bins
                collection_bins.push({
                    "incentive":this.state.bin_incentive,
                    lower:this.state.bin_lower,
                    upper : this.state.bin_upper
                })
                this.setState(
                    {
                        collection_bins:collection_bins,
                        bin_per:0,
                        bin_lower :0,
                        bin_upper:0            
                    }
                )
                break;
            }
            default:{
                console.log("default case")
            }
            }
        }
    }


    handleAddAllowance = ()=>{
        console.log("bye")
        if(this.state.allowanceType && this.state.allowance){
            this.setState({
                allowances : [ ...this.state.allowances, { key:this.state.allowanceType , paymentType: this.state.allowanceType , amount:this.state.allowance }]
            }
            ,
            ()=>{
                this.setState({
                    allowanceType:null,
                    allowance:null
                })
            }
            )
        }else{
            message.error("please fill data!")
        }

    }
    handleAddDeduction = ()=>{
        if (this.state.deduction){
        this.setState({
            deductions : [ ...this.state.deductions, { key:this.state.deductionType , paymentType: this.state.deductionType , amount: this.state.deduction }]
        }
        ,
        ()=>{
            this.setState({
                deductionType:null,
                deduction:null
            })
        }
        
        )
        }else{
            message.error("Please fill data!")
        }
    }

    generatePayslipClicked =()=>{
        confirm(
            {
                title : "Are you sure?",
                content : "This operation cannot be reverted. Please confirm!",
                onOk : ()=>{
                    this.generatePayslip()
                }
                
            }
        )
    }

    generatePayslip = ()=>{
        this.setState({generatePayslipLoading:true , showPayslip:false})
        const data = {
            "from_date" : this.state.from_date.format("YYYY-MM-DD"),
            "to_date" : this.state.to_date.format("YYYY-MM-DD"),
            "allowances": [
                {description:"Basic Salary" , amount:this.state.basic_salary},
                {description:"Cash Sale Commission" , amount:this.state.cash_sale_commission} ,
                {description:"Installment Sales Commission" , amount:this.state.installment_sale_commission} ,
                {description:"Collection Commission" , amount:this.state.collection_commission},
                ...this.state.allowances.map(allowance =>({description:allowance.paymentType , amount:allowance.amount}))],
            "deductions": [...this.state.deductions.map(deduction =>({description:deduction.paymentType , amount:deduction.amount}))]
        }
        axios.post(`${this.props.entity.server}/hr/employee/${this.props.match.params.id}/payslip/generate/`,data)
        .then(
            response => {
                const payslipData = response.data
                this.setState({
                    showPayslip:true,
                    generatePayslipLoading:false,
                    payslipData
                })
            }
        )
        .catch(
            error => {
                message.error("Generating Payslip failed!")
                this.setState({
                    generatePayslipLoading:false
                })
            }
        )
    }



    render(){
     
        return (
            <Fragment>
                <Row style={{ padding:"10px"}} gutter = {10}>
                    <Col span={24}>
                        <Descriptions title="Employee Details" column={4}>
                            <Descriptions.Item label="Employee Name">{this.state.employee_name}</Descriptions.Item>
                            <Descriptions.Item label="NIC">{this.state.employee_nic}</Descriptions.Item>
                            <Descriptions.Item label="Address">{this.state.employee_address}</Descriptions.Item>
                            <Descriptions.Item label="Employee Type">{this.state.employee_type}</Descriptions.Item>         
                        </Descriptions>
                    </Col>

                </Row>    
                <Row gutter={10}>
                    <Col span={12}>           
                    <Row gutter = {10}>
                        <Col span={6}>
                            <Form.Item label="Basic Salary">
                                <InputNumber value={this.state.basic_salary} onChange={(value) => this.onNumberChange("basic_salary",value)} style={{width:150}} ></InputNumber>
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="From Date">
                                <DatePicker value={this.state.from_date} onChange = {(date, dateString) => this.onDateChange("from_date",date)}></DatePicker>
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label="To Date">
                            <DatePicker value={this.state.to_date} onChange = {(date, dateString) => this.onDateChange("to_date",date)}></DatePicker>
                            </Form.Item>
                        </Col>      
                    </Row>
                <Row gutter = {10}>
                    <Col span={6}>
                        <Form.Item label="Total Cash Sales">
                            <InputNumber disabled value={this.state.total_cash_sale} onChange={(value) => this.onNumberChange("total_sales",value)} style={{width:150}} ></InputNumber>
                        </Form.Item>
                    </Col>
                    <Col  style={{paddingTop:"38px"}} span={6}>
                        <Form.Item label="">
                            <Button  onClick={() => this.setState({show_cash_sales_bins:true})}>Calculate Comm.</Button>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="Cash Sales Commission">
                            <InputNumber value={this.state.cash_sale_commission} readOnly style={{width:150}} ></InputNumber>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter = {10}>
                    <Col span={6}>
                        <Form.Item label="Total Installment Sales">
                            <InputNumber disabled value={this.state.total_installment_sale} onChange={(value) => this.onNumberChange("total_installment_sale",value)} style={{width:150}} ></InputNumber>
                        </Form.Item>
                    </Col>
                    <Col  style={{paddingTop:"38px"}} span={6}>
                        <Form.Item label="">
                            <Button  onClick={() => this.setState({show_sales_bins:true})}>Calculate Comm.</Button>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="Sales Commission">
                            <InputNumber value={this.state.installment_sale_commission} readOnly style={{width:150}} ></InputNumber>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter = {10}>
                    <Col span={6}>
                        <Form.Item label="Total Collection">
                            <InputNumber disabled value={this.state.total_collection} onChange={(value) => this.onNumberChange("total_collection",value)} style={{width:150}} ></InputNumber>
                        </Form.Item>
                    </Col>
                    <Col style={{paddingTop:"38px"}} span={6}>
                        <Form.Item label="">
                            <Button onClick={() => this.setState({show_collection_bins:true})} >Calculate Comm.</Button>
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item label="Collection Commission">
                            <InputNumber value={this.state.collection_commission} readOnly style={{width:150}} ></InputNumber>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter = {10}>
                    <Col span={6}>
                        <Form.Item label="Allowance Type">
                            <Select onChange={v=>this.setState({allowanceType:v})} style={{width:150}}> 
                                {allowanceTypes.map((value,index) => <Option value={value}> {value} </Option>)}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col  span={6}>
                        <Form.Item label="Amount">
                            <InputNumber value={this.state.allowance} onChange={v=>this.setState({allowance:v})}  style={{width:150}} ></InputNumber>
                        </Form.Item>
                    </Col>
                    <Col style={{paddingTop:"38px"}} span={6}>
                        <Form.Item label="">
                            <Button  onClick={this.handleAddAllowance} block type="primary" >Add</Button>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter = {10}>
                    <Col span={6}>
                        <Form.Item label="Deduction Type">
                            <Select onChange={v=>this.setState({deductionType:v})} style={{width:150}}>
                                {deductionTypes.map((value,index) => <Option value={value}> {value} </Option>)}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col  span={6}>
                        <Form.Item label="Amount">
                            <InputNumber value={this.state.deduction} onChange={v=>this.setState({deduction:v})} style={{width:150}}  ></InputNumber>
                        </Form.Item>
                    </Col>
                    <Col style={{paddingTop:"38px"}} span={6}>
                        <Form.Item label="">
                            <Button onClick={this.handleAddDeduction} block type="primary" >Add</Button>
                        </Form.Item>
                    </Col>
                </Row>
                </Col>
                <Col style={{padding:"20px"}} span={12}>
                    <Row>
                        <Table pagination={false} dataSource={this.formatTableData()} columns={this.columns}         
                        footer = {()=><h2>Final Salary : Rs.{this.formatTableData().reduce((total , obj)=> total + parseFloat(obj.amount) , 0)}</h2>}></Table>
                    </Row>
                    <Row>           
                        <Button loading={this.state.generatePayslipLoading} onClick={this.generatePayslipClicked} size="large" block type="primary" > Generate Payslip </Button>         
                    </Row>
                   
                    <Row>
                        <Col offset={12}>

                        </Col>
                    </Row>
                </Col>

                </Row>
                <Modal
                    title = "Cash Sales Commission Plan"
                    visible = {this.state.show_cash_sales_bins}
                    onOk = {() => this.handleCommisionPlanOk("cash_sales")}
                    onCancel = {() => this.setState({show_cash_sales_bins:false ,cash_sales_bins:[] })}
                >
                    <Row>
                        <Form>
                            <Col span={5}>
                                <FormItem label="Incentive Amount">
                                    <InputNumber value={this.state.bin_per} onChange={value => this.setState({bin_incentive:value})} min={0}  step={0.01}></InputNumber>
                                </FormItem> 
                            </Col>
                            <Col span={5}>
                                <FormItem label="Lower">
                                    <InputNumber value={this.state.bin_lower} onChange={value => this.setState({bin_lower:value})} min={0} ></InputNumber>
                                </FormItem> 
                            </Col>
                            <Col span={5}>
                                <FormItem label="Upper">
                                    <InputNumber value={this.state.bin_upper} onChange={value => this.setState({bin_upper:value},()=>console.log(this.state))} min={0} ></InputNumber>
                                </FormItem> 
                            </Col>
                            <Col style={{paddingTop:"43px"}} span={5}>
                                <Button name="cash_sales" onClick={this.onAddRuleButtonClicked} type="primary"> Add Rule</Button>
                            </Col>
                            
                        </Form>
                    </Row>
                    <Table size="small" columns={this.bin_columns} dataSource={this.state.cash_sales_bins}></Table>
                    
                </Modal>
                <Modal
                    title = "Installment Sales Commission Plan"
                    visible = {this.state.show_sales_bins}
                    onOk = {() => this.handleCommisionPlanOk("installment_sales")}
                    onCancel = {() => this.setState({show_sales_bins:false ,sales_bins:[] })}
                >
                    <Row>
                        <Form>
                            <Col span={5}>
                                <FormItem label="Incentive Amount">
                                    <InputNumber value={this.state.bin_incentive} onChange={value => this.setState({bin_incentive:value})} min={0}  step={0.001}></InputNumber>
                                </FormItem> 
                            </Col>
                            <Col span={5}>
                                <FormItem label="Lower">
                                    <InputNumber value={this.state.bin_lower} onChange={value => this.setState({bin_lower:value})} min={0} ></InputNumber>
                                </FormItem> 
                            </Col>
                            <Col span={5}>
                                <FormItem label="Upper">
                                    <InputNumber value={this.state.bin_upper} onChange={value => this.setState({bin_upper:value},()=>console.log(this.state))} min={0} ></InputNumber>
                                </FormItem> 
                            </Col>
                            <Col style={{paddingTop:"43px"}} span={5}>
                                <Button name="installment_sales" onClick={this.onAddRuleButtonClicked} type="primary"> Add Rule</Button>
                            </Col>
                            
                        </Form>
                    </Row>
                    <Table size="small" columns={this.bin_columns} dataSource={this.state.sales_bins}></Table>
                    
                </Modal>
                <Modal
                    title = "Collection Commision Plan"
                    visible = {this.state.show_collection_bins}
                    onOk = {() => this.handleCommisionPlanOk("collection")}
                    onCancel = {() => this.setState({show_collection_bins:false ,collection_bins:[] })}
                >    
                    <Row gutter={20}>
                        <Form>
                            <Col span={8}>
                                <FormItem label="Incentive Amount">
                                    <InputNumber style={{width:"100%"}} value={this.state.bin_incentive} onChange={value => this.setState({bin_incentive:value})} min={0}  step={0.01}></InputNumber>
                                </FormItem> 
                            </Col>
                            <Col span={5}>
                                <FormItem label="Lower">
                                    <InputNumber style={{width:"100%"}} value={this.state.bin_lower} onChange={value => this.setState({bin_lower:value})} min={0} ></InputNumber>
                                </FormItem> 
                            </Col>
                            <Col span={5}>
                                <FormItem label="Upper">
                                    <InputNumber style={{width:"100%"}}  value={this.state.bin_upper} onChange={value => this.setState({bin_upper:value},()=>console.log(this.state))} min={0} ></InputNumber>
                                </FormItem> 
                            </Col>
                            <Col style={{paddingTop:"43px"}} span={6}>
                                <Button block name="collection" onClick={this.onAddRuleButtonClicked} block type="primary"> Add Rule</Button>
                            </Col>
                            
                        </Form>
                    </Row>
                    <Table size="small" columns={this.bin_columns} dataSource={this.state.collection_bins}></Table>           
                </Modal>
                {this.state.showPayslip && <Payslip payslipData={this.state.payslipData} />}
            </Fragment>
        )
    }
}

const mapStateToProps = state => ({entity: state.entity})

export default connect(mapStateToProps,null)(Payroll)